/**
 * Labstep
 *
 * @module screens/ResourceLocation/Show/Center
 * @desc ResourceLocation Show Center
 */

import { EntityPrimaryInfoImage } from 'labstep-web/components/Entity/PrimaryInfo/Image';
import { EntityUserCard } from 'labstep-web/components/EntityUser/Card';
import { MetadataManagerContainer as MetadataManager } from 'labstep-web/components/Metadata/Manager';
import {
  Action,
  ResourceLocationActionMenu,
} from 'labstep-web/components/ResourceLocation/Action/Menu';
import { ResourceLocationBreadcrumb } from 'labstep-web/components/ResourceLocation/Breadcrumb';
import { ResourceLocationEmptyStateMap } from 'labstep-web/components/ResourceLocation/EmptyState/Map';
import { ResourceLocationMapModalCreate } from 'labstep-web/components/ResourceLocation/MapModalCreate';
import { InformationCard } from 'labstep-web/core/Card/Information';
import type React from 'react';
import styles from './styles.module.scss';
import type { IResourceLocationShowCenterProps } from './types';

export const ResourceLocationShowCenter: React.FC<
  IResourceLocationShowCenterProps
> = ({ resourceLocation }) => {
  return (
    <div
      id="resource-location-show-screen"
      className={styles.container}
    >
      <InformationCard
        additionalActions={
          <EntityUserCard entity={resourceLocation} />
        }
        actionMenu={
          <ResourceLocationActionMenu
            resourceLocation={resourceLocation}
            actions={[
              Action.delete,
              Action.update_outer,
              Action.stock_check,
            ]}
          />
        }
        breadcrumb={
          <ResourceLocationBreadcrumb
            resourceLocation={resourceLocation}
          />
        }
        primaryInfo={
          <EntityPrimaryInfoImage entity={resourceLocation} />
        }
        secondaryInfo={<MetadataManager entity={resourceLocation} />}
        bottom={
          <ResourceLocationMapModalCreate
            resourceLocation={resourceLocation}
            createAction={
              <ResourceLocationEmptyStateMap
                resourceLocation={resourceLocation}
              />
            }
          />
        }
      />
    </div>
  );
};
